module.exports = __webpack_public_path__ + "static/media/loading_BG.eb4b6492.gif";